module.exports = __webpack_public_path__ + "static/media/trainVideo9.f0b30b23.mp4";